import { wpFetch } from 'src/helpers/wpApiHandler';

const useGetNewLeads = async (params) => {
  const { latestLead, companyId, recruiterId } = params;
  const path = recruiterId
    ? ['recent-leads', latestLead, companyId, recruiterId]
    : ['recent-leads', latestLead, companyId];

  const response = wpFetch(path, { method: 'GET' });

  return response;
};

export default useGetNewLeads;
